<template>
	<div :class="{ 'side-menu-container--opened': sideMenuOpened, 'side-menu-container--closed': !sideMenuOpened }">
		<transition name="fade" v-if="userInfo">
			<div :class="{ 'side-menu-student': userRoles === 'Student', 'side-menu': userRoles !== 'Student', 'side-menu--opened': sideMenuOpened, 'side-menu--closed': !sideMenuOpened }">
				<a class="side-menu__header flex">
					<img :src=" sideMenuOpened ? require('@/assets/img/university-logo.svg') : require('@/assets/img/university-logo-small.svg') " alt="uni logo" />
				</a>

				<a class="side-menu-toggle" :class="{ 'side-menu-toggle--opened': !sideMenuOpened }" href="" @click.prevent="sideMenuOpened = !sideMenuOpened"></a>

				<!-- Icon + text -->
				<div  class="side-menu__opened-content" v-show="sideMenuOpened">
					<div class="side-menu__student-ava">
						<img v-if="!testStudent" class="side-menu__student-image" :src="userInfo.logoUrl ? apiImg + userInfo.logoUrl : require('@/assets/img/default-profile-image.png')">
					</div>

					<p class="side-menu__student-name" >{{`${userInfo.fname && userInfo.fname} ${userInfo.iname && userInfo.iname[0]+ '.'} ${userInfo.oname ? userInfo.oname[0] +'.' : '' }`}}</p>
					<span class="side-menu__role"  v-if="userRoles === 'Teacher'">Преподаватель</span>
					<span class="side-menu__role"  v-if="userRoles === 'Metodist'">Методист</span>
					<span class="side-menu__role"  v-if="userRoles === 'Student'">Студент</span>

                    <slot v-if="testStudent" name="testStudent"></slot>
					<ul v-else class="side-menu__nav-bar">
						<p class="side-menu__name">МЕНЮ</p>
						<li
							v-for="(item, key) in calculateAccess" :key="key"
							class="side-menu__nav-item side-menu__nav-item--main hover-item"
							:class="{'active_nav': $route.name == item.path}"
							@click.prevent="$router.push({ name: item.path })"
						>
                            <inline-svg :src="require(`../../assets/SideMenuIcons/${item.icon}.svg`)" />

							<p>{{ item.text }}</p>
						</li>
						<li class="side-menu__nav-item side-menu__nav-item--stats" @click="openInfo = true">
                        <img svg-inline :src="require('../../assets/img/icons/Info.svg')" />
                        <p>Помощь</p>
                    </li>
					</ul>

                    <div class="side-menu__exit" @click.prevent="!testStudent ? dialog = true : dialogEndTest = true">
                        <inline-svg :src="require('@/assets/SideMenuIcons/Logout.svg')" />
                        <p class="pt-1 ml-4">
                            {{ !testStudent ? 'Выход' : 'Завершить' }}
                        </p>
                    </div>
				</div>

				<!-- Just icon -->
				<div class="side-menu__closed-content" v-show="!sideMenuOpened">
					<div class="side-menu__student-ava">
						<img class="side-menu__student-image" :src="userInfo.logoUrl ? apiImg + userInfo.logoUrl : require('@/assets/img/default-profile-image.png')">
					</div>

					<ul v-if="!testStudent" class="side-menu__nav-bar">
                        <!-- :class="{'active': $route.name == item.path}" -->
						<li
							v-for="(item, key) in calculateAccess" :key="key"
							class="side-menu__nav-item side-menu__nav-item--main"
							@click.prevent="nextTo(item.path)"
						>
                            <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <inline-svg v-bind="attrs" v-on="on" :src="require(`../../assets/SideMenuIcons/${item.icon}.svg`)" />
                                </template>
                                <span>{{ item.text }}</span>
                            </v-tooltip>
						</li>
						<li class="side-menu__nav-item side-menu__nav-item--stats" @click="openInfo = true">
                            <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <img v-bind="attrs" v-on="on" svg-inline :src="require('../../assets/img/icons/Info.svg')" />
                                </template>
                                <span>Помощь</span>
                            </v-tooltip>
                        </li>
					</ul>

					<div v-if="testStudent" class="side-menu__exit" @click.prevent="dialogEndTest = true" title="Завершить">
                        <inline-svg :src="require('../../assets/SideMenuIcons/Logout.svg')" />
					</div>

                    <div v-if="!testStudent" class="side-menu__exit" @click.prevent="dialog = true">
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <inline-svg v-bind="attrs" v-on="on" :src="require('../../assets/SideMenuIcons/Logout.svg')" />
                            </template>
                            <span>Выйти из системы</span>
                        </v-tooltip>
					</div>
				</div>

                <v-dialog v-model="openInfo" max-width="410" persistent>
                    <v-card>
                        <v-card-title class="text-h5 grey lighten-2">
                            Помощь
                        </v-card-title>

                        <v-card-text class="pt-6 pb-0 justify-left font-weight-regular">
                            <p class="text-subtitle-1">
                                <a :href="`${apiPdf}${calculateRole()}.pdf`" target="_blank">Руководство пользователя</a>
                            </p>
                        </v-card-text>

                        <v-card-text class="pb-2 pt-0 justify-left font-weight-bold">
                            Служба технической поддержки:
                        </v-card-text>

                        <v-card-text class="pt-2 justify-left font-weight-regular">
                            Время работы: 09:00-18:00 (МСК)
                        </v-card-text>

                        <v-card-text class="pt-0 pb-2 d-flex justify-left">
                            <v-btn @click="sendGoToStpForm" dark color="#4854FE">
                                <v-icon class="mr-2">mdi-forum</v-icon>
                                Написать службе поддержки
                            </v-btn>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                        <v-spacer></v-spacer>
                            <v-btn color="#4854FE" text @click="openInfo = false">
                                Закрыть
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

				<v-dialog v-model="dialog" max-width="410" persistent >
					<v-card>
                        <v-card-title class="text-h5" style="word-break: normal;">
                            Вы уверены, что хотите выйти?
                        </v-card-title>

                        <v-card-actions>
                            <div class="text-center" style="width:100%">
                                <v-btn text @click="dialog = false" class="mr-2 act">Нет</v-btn>

                                <v-btn class="act" text @click="logoutSystem()">Да</v-btn>
                            </div>
                        </v-card-actions>
					</v-card>
				</v-dialog>

                <v-dialog v-model="dialogEndTest" max-width="690" persistent >
					<v-card>
                        <v-card-title class="text-h5" style="word-break: normal;">
                            Вы уверены, что хотите завершить прохождение теста?
                        </v-card-title>

                        <v-card-actions>
                            <div class="text-center" style="width:100%">
                                <v-btn text @click="dialogEndTest = false" class="mr-2 act">Нет</v-btn>

                                <v-btn class="act" text @click="$router.replace(userRoles === 'Student' ? '/lkstudents/tests' : userRoles === 'Teacher' ? '/teacher/tasks' : '/lk/test-tasks' )">Да</v-btn>
                            </div>
                        </v-card-actions>
					</v-card>
				</v-dialog>

			</div>
		</transition>

		<div v-if="$route.name == 'Human'" class="metodist-side-bar" :class="{ 'opened': sideMenuOpened, 'closed': !sideMenuOpened }">
			<MetodistSideBar :mobile="mobile" @toggleMenu="toggleMenu()" />
		</div>

  </div>
</template>

<script>
import MetodistSideBar from '@/components/MetodistSideBar/MetodistSideBar.vue'
import inlineSvg from 'vue-inline-svg'
import { mapGetters, mapActions, mapMutations } from "vuex";
import "./SideMenu.scss";
// import { InlineSvgPlugin } from 'vue-inline-svg';
export default {
	name: "SideMenu",
	components: {
		MetodistSideBar,
        inlineSvg
	},
	props: {
		mobile: Boolean,
		testStudent: Boolean
	},
	computed: {
		...mapGetters({
			apiImg: "apiImg",
			userRoles: "login/userRoles",
			userInfo: "user/userInfo",
			apiUrl: 'apiUrl',
			apiPdf: 'apiPdf'

		}),
		calculateAccess() {
			let res = [];
			for (let i = 0; i < this.menu.length; i++) {
				for (let j = 0; j < this.menu[i].roles.length; j++) {
					if(this.menu[i].roles[j].role === this.userRoles && this.menu[i].roles[j].view) {
						res.push(this.menu[i])
					}
				}
			}
			return res
		}
	},
	watch: {
		sideMenuOpened(val) {
			this.setSideMenu(val);
		}
	},
	data() {
		return {
			sideMenuOpened: false,
			dialog: false,
			openInfo: false,
			dialogEndTest: false,
			menu: [
				{ id: 1, text: 'Профиль', path: 'Profile', icon: 'Profile', roles: [{ role: 'Teacher', view: true}, { role: 'Metodist', view: true}, { role: 'Student', view: true}] },
				{ id: 2, text: 'Обучение', path: 'training', icon: 'OpenBook', roles: [{ role: 'Student', view: true}, { role: 'Teacher', view: true}] },
				{ id: 3, text: 'Тестирование', path: 'tests', icon: 'List', roles: [{ role: 'Student', view: true}] },
				{ id: 4, text: 'Задания', path: 'tasks', icon: 'Task', roles: [{ role: 'Teacher', view: true}] },
				{ id: 5, text: 'Студенты', path: 'students', icon: 'AcademicCap', roles: [{ role: 'Teacher', view: true}] },
				{ id: 6, text: 'Оценка знаний', path: 'Grade', icon: 'AssessmentOfKnowledge', roles: [{ role: 'Teacher', view: true}, { role: 'Student', view: false}] },
				{ id: 7, text: 'Оценка знаний', path: 'Assessment', icon: 'AssessmentOfKnowledge', roles: [{ role: 'Student', view: true}] },
				{ id: 8, text: 'Знания', path: 'Knowledge', icon: 'AcademicCap', roles: [{ role: 'Metodist', view: true }] },
				{ id: 9, text: 'Медиахранилище', path: 'MediaStorage', icon: 'MediaStorage', roles: [{ role: 'Metodist', view: true}] },
				{ id: 10, text: 'Пациенты', path: 'Patients', icon: 'Patients', roles: [{ role: 'Metodist', view: true}] },
				{ id: 11, text: 'Тесты', path: 'TestTasks', icon: 'List', roles: [{ role: 'Metodist', view: true}] },
				{ id: 12, text: 'Справочники', path: 'Directory', icon: 'Book', roles: [{ role: 'Metodist', view: true}] },
			]
		};
	},
	methods: {
		...mapActions({
			getUserInfo: "user/getUserInfo",
			logout: "login/logout"
		}),
		...mapMutations({
			setSideMenu: 'setSideMenu'
		}),
        sendGoToStpForm() {
            window.open('http://y.sechenov.ru/form/b8b5265e-6bab-4b9b-8f6d-65b29f37c534', '_blank');
        },
		toggleMenu() {
			this.$emit('toggleMenu');
		},
		calculateRole() {
            if(this.userRoles === 'Metodist') return 'metodist'
            if(this.userRoles === 'Teacher') return 'teacher'
            if(this.userRoles === 'Student') return 'student'
        },
        nextTo(path) {
            if(this.$route.name === path) {
                return;
            }

            this.$router.push({ name: path })
        },
        getPhotoUrl(student) {
            if (student.logoUrl) {
                return `${this.apiImg}${student.logoUrl}`;
            }

            if (student.gender === 0) {
                return require('@/assets/img/avatar-boy.png');
            }

            if (student.gender === 1) {
                return require('@/assets/img/avatar-girl.png');
            }

            return require('@/assets/img/default-profile-image.png');
        },
        logoutSystem() {
            this.logout()
                .then(() => {
                    this.$router.replace('/');
                })
        }
	},
	mounted() {
		this.getUserInfo();
	},
    created() {
        // Если Методист НЕ прикреплен к организации Сеченовский, то он НЕ видит разделы Знания и Справочники
        let LShasMainOrganization = JSON.parse(localStorage.getItem('hasMainOrganization'));

        if(!LShasMainOrganization) {
            this.menu = this.menu.filter((f) => f.id !== 8 && f.id !== 12)
        }
        if(this.testStudent) this.sideMenuOpened = true;
    }
};
</script>
